import IssueAttachmentDescription from './IssueAttachmentDescription';
import {connect} from '../../app/connect';
import {getUserNameWithCompanyGetter} from '../../app/selectors';

const mapStateToProps = (state, ownProps) => {
  const createdBy = ownProps.attachment.createdBy;
  const getUserNameWithCompany = getUserNameWithCompanyGetter(state);
  return {
    userNameDisplayNameWithCompany: getUserNameWithCompany(createdBy)
  };
};

export default connect(mapStateToProps)(IssueAttachmentDescription);
